import { C } from "../constants";

export default function VaultLogo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <rect x="10" y="18" width="68" height="65" rx="8" fill={C.blueDark} />
      <rect x="14" y="22" width="60" height="57" rx="6" fill={C.blue} />
      <circle cx="44" cy="50" r="12" fill={C.blueDark} opacity="0.5" />
      <circle cx="44" cy="50" r="6" fill={C.blueDark} opacity="0.7" />
      <rect x="12" y="30" width="3" height="8" rx="1.5" fill={C.blueDark} />
      <rect x="12" y="55" width="3" height="8" rx="1.5" fill={C.blueDark} />
      <rect x="73" y="30" width="3" height="8" rx="1.5" fill={C.blueDark} />
      <rect x="73" y="55" width="3" height="8" rx="1.5" fill={C.blueDark} />
      <polygon points="66,2 54,30 62,30 58,58 70,26 62,26" fill={C.yellow} stroke="#E6B800" strokeWidth="0.5" strokeLinejoin="round" />
      <polygon points="66,2 58,22 64,22 58,58 66,30 62,30" fill="#FFE44D" opacity="0.6" />
    </svg>
  );
}
